export default "__VITE_ASSET__CJRGGnkF__"